
import { useNavigate } from "react-router-dom";
import { hostImg } from "../../callApi/AxiosCall";
import { getPostApi } from "../../callApi/postApi";
import CustomBottom from "../../components/CustomBottom";
import CustomButton from "../../components/CustomButton";
import CustomHeader from "../../components/CustomHeader";
import CustomPagination from "../../components/CustomPagination";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";

export default function Knowledge() {
  const [nowPage, setnowPage] = useState(1);
  const [allPage, setallPage] = useState(1);
  const [contentData, setcontentData] = useState(null);
  const [count, setcount] = useState(0)
  const router = useNavigate();

  useEffect(() => {
    if (nowPage) {
      getContent();
    }
  }, [nowPage]);
  const getContent = async () => {
    const res = await getPostApi({
      limit: 3,
      page: nowPage,
      post_categories_id: 2,
    });
    if (res?.status == 200) {
      let temp = [...res.data.data.post];
      for (let i = 0; i < res.data.data.post.length; i++) {
        if (res.data.data.post[i]?.content) {
          temp[i].content_json = JSON.parse(res.data.data.post[i]?.content);
          let FirstImg = null;
          let FirstText = null;
          for (let j = 0; j < temp[i].content_json?.html?.length; j++) {
            for (let k = 0; k < temp[i].content_json?.html[j].length; k++) {
              if (
                FirstImg == null &&
                temp[i].content_json.html[j][k].type == "image"
              ) {
                FirstImg = temp[i].content_json?.html[j][k].value;
              } else if (
                FirstText == null &&
                temp[i].content_json.html[j][k].type == "text"
              ) {
                FirstText = temp[i].content_json?.html[j][k].value;
              }
              if (FirstImg != null && FirstText != null) {
                break;
              }
            }
            if (FirstImg != null && FirstText != null) {
              break;
            }
          }
          temp[i].content_json.img = FirstImg;
          temp[i].content_json.text = FirstText;
        }
      }
      setcontentData(temp ?? []);
      setallPage(Math.ceil(res?.data?.data?.count / 3));
      setcount(res?.data?.data?.count )
    }
  };
  const data = [
    {
      img: "/img/k01.jpg",
      no: ".01",
      title: "Circular Texttile",
      text: ["แนวคิด Circular Design สำหรับสิ่งทอชุมชน", "WHAT?", "WHY?"],
      link: "https://ftcdc.udru.ac.th/website/document/pdf/Circular_Design_FTCDC_Watermark.pdf",
    },

    {
      img: "/img/k02.jpg",
      no: ".02",
      title: "สรุปผลโครงการ",
      text: [
        "การยกระดับกระบวนการผลิตการออกแบบพัฒนาผ้าทอพื้นเมืองสู่สากล ปีงบประมาณ 2563",
      ],
      link: "https://ftcdc.udru.ac.th/website/document/pdf/FTCDC_2563.pdf",
    },
    {
      img: "/img/k03.jpg",
      no: ".03",
      title: "สรุปผลโครงการ",
      text: [
        "การยกระดับกระบวนการผลิตการออกแบบพัฒนาผ้าทอพื้นเมืองสู่สากล ปีงบประมาณ 2564",
      ],
      link: "https://ftcdc.udru.ac.th/website/document/pdf/FTCDC_2564.pdf",
    },
    {
      img: "/img/k04.jpg",
      no: ".04",
      title: "สรุปผลโครงการ",
      text: [
        "การยกระดับกระบวนการผลิตการออกแบบพัฒนาผ้าทอพื้นเมืองสู่สากล ปีงบประมาณ 2566",
      ],
      link: "https://ftcdc.udru.ac.th/website/document/pdf/FTCDC_2565.pdf",
    },
  ];
  const Section1 = () => {
    return (
      <div className="flex flex-col items-center">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mt-5 mb-5 w-full">
          {contentData?.map((item, i) => {
            return (
              <div
                key={i}
                className="flex flex-col gap-5 items-start  font-medium text-xl bg-white drop-shadow-md  rounded-lg "
              >
                <img
                  src={
                    item?.content_json.img
                      ? "https://ftcdc.udru.ac.th/ftcdc-api/storage/app/public/upload/UploadImg/" +
                        item?.content_json.img
                      : "/img/logo.png"
                  }
                  className="w-full h-[300px] object-cover rounded-lg max-h-[300px]"
                />
                <div className="  flex flex-col px-4 w-full">
                  <p className="text-[#B36427] font-bold text-[24px]">
                    {item.title}
                  </p>
                  <p className="mt-7 font-medium text-base line-clamp-6 overflow-hidden text-ellipsis ">
                    {item?.content_json?.text != null ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item?.content_json?.text,
                        }}
                      />
                    ) : (
                      <p></p>
                    )}
                  </p>
                  <p className="text-center text-sm text-[#858485] mt-6">
                    {format(new Date(item.updated_at), "MMMM dd,yyy")} By Admin
                  </p>
                  <CustomButton
                    onClick={() => {
                      router("/knowledge/" + item.id);
                    }}
                    txt={"อ่านเพิ่มเติม"}
                    classAdditional=" font-semibold text-lg self-center my-5"
                  />
                </div>
              </div>
            );
          })}
        </div>
        <CustomPagination
          now={nowPage}
          all={allPage}
          onChangePage={(page) => {
            setnowPage(page);
          }}
        />
      </div>
    );
  };
  const Section2 = () => {
    return (
      <div className="flex flex-col items-center">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-5 mb-5 w-full">
          {data?.map((item, i) => {
            return (
              <a
                href={item.link}
                key={i}
                target="_blank"
                className="grid grid-cols-2 gap-5 items-center  font-medium text-xl bg-white drop-shadow-md  rounded-lg "
              >
                <img
                  src={item.img}
                  className="w-full object-cover rounded-lg md:max-h-[500px]"
                />
                <div className="  flex flex-col pr-4 h-full">
                  <p
                    className="font_Barlow font-bold "
                    style={{ fontSize: "140px", lineHeight: "140px" }}
                  >
                    {item.no}
                  </p>
                  <p className=" font-bold text-4xl">{item.title}</p>
                  {item.text.map((txt, j) => {
                    return (
                      <p
                        key={j}
                        className=" mt-3 font-medium text-lg line-clamp-6 overflow-hidden text-ellipsis "
                      >
                        {txt}
                      </p>
                    );
                  })}

                  <CustomButton
                    txt={"อ่านเพิ่มเติม"}
                    classAdditional=" font-semibold text-lg self-end mt-auto mb-5"
                  />
                </div>
              </a>
            );
          })}
        </div>
        {/* <CustomPagination
          now={nowPage}
          all={allPage}
          onChangePage={(page) => {
            setnowPage(page);
          }}
        /> */}
      </div>
    );
  };
  return (
    <div className="fade_In">
      <CustomHeader />

      <div
        className="flex flex-row items-center gap-4  pt-[180px]"
        style={{ justifyContent: "center" }}
      >
        <div className="w-5 h-5 bg-[#B36427]" />
        <div className=" font-semibold" style={{ fontSize: "36px" }}>
          องค์ความรู้ 
        </div>
        {count>0?<div className="text-xl px-2 py-1 rounded-full border-[3px] border-primary flex flex-col justify-center items-center ">{count}</div>:''}
        <div className="w-5 h-5 bg-[#B36427]" />
      </div>
      <div className="px-[20px] py-[24px] flex flex-col items-center ">
        <Section1 />
      </div>
      <div className="bg-[#B36427] px-[20px] py-[24px] flex flex-col items-center ">
        <Section2 />
      </div>
      <CustomBottom />
    </div>
  );
}
